import { AUTH_TOKEN } from '@repo/constants';

export const logout = () => {
  localStorage.removeItem('id_token_refresh');
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem('clientId');
};
